module.exports = __webpack_public_path__ + "bd3910527ccff435c8b25b4ffc355def.png";